import { render, staticRenderFns } from "./DefDef.vue?vue&type=template&id=b6e534cc&"
import script from "./DefDef.vue?vue&type=script&lang=ts&"
export * from "./DefDef.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports